var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"global-canvas-launcher",attrs:{"type":"button","title":"打开当前项目画布","aria-label":"打开当前项目画布"},on:{"click":_vm.openCanvas}},[_c('i',{staticClass:"el-icon-s-grid",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("画布")])])
}
var staticRenderFns = []

export { render, staticRenderFns }